// extracted by mini-css-extract-plugin
module.exports = {"center":"center__s0ieOFuy1NVrQ","wrapper":"wrapper__mrkReiNagdol8","label":"label__3Mubh4l2g7-YL"};